// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const DashboardLg = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M18.6 3H5.4C4.07452 3 3 4.07452 3 5.4V18.6C3 19.9255 4.07452 21 5.4 21H18.6C19.9255 21 21 19.9255 21 18.6V5.4C21 4.07452 19.9255 3 18.6 3Z" stroke={color} strokeWidth="2" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 13.5L17 10M14.4286 15.25C14.4286 16.2165 13.6611 17 12.7143 17C11.7675 17 11 16.2165 11 15.25C11 14.2835 11.7675 13.5 12.7143 13.5C13.6611 13.5 14.4286 14.2835 14.4286 15.25Z" stroke={color} strokeWidth="2" strokeLinecap="round" />
        <path d="M7 12C7 9.23857 9.38781 7 12.3333 7C13.3048 7 14.2156 7.24348 15 7.66891" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>

);
